import React, { useState, useEffect, useRef } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { SquaresFour, Image, BookOpen, UploadSimple } from "phosphor-react";
import { motion, AnimatePresence } from "framer-motion";
import { User, FileText, Star, Book, Cast, Heart, Settings, Radio, MessagesSquare} from "lucide-react";
import { BiSleepy } from "react-icons/bi";
import { FaRegFileAlt } from "react-icons/fa";

const Sidebar = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const dropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isActiveLink = (path) => {
    if (location.pathname === path) {
      return true;
    }
    if (path === "/album") {
      return (
        location.pathname.startsWith("/album/") ||
        location.pathname === "/album" ||
        location.pathname === "/new-album" ||
        location.pathname.startsWith("/edit-album/")
      );
    }
    if (path === "/content") {
      return (
        location.pathname.startsWith("/content/") ||
        location.pathname === "/content" ||
        location.pathname === "/new-content" ||
        location.pathname.startsWith ("/view-content/") ||
        location.pathname.startsWith("/edit-content/")
      );
    }
    if (path === "/chapters") {
      return (
        location.pathname.startsWith("/chapters/") ||
        location.pathname === "/chapters" ||
        location.pathname === "/new-chapter" ||
        location.pathname.startsWith("/edit-chapter/")
      );
    }
    if (path === "/characters") {
      return (
        location.pathname.startsWith("/characters/") ||
        location.pathname === "/characters" ||
        location.pathname === "/new-characters" ||
        location.pathname.startsWith("/edit-character/")
      );
    }
    if (path === "/bulk_upload") {
      return (
        location.pathname.startsWith("/bulk_upload") ||
        location.pathname.startsWith("/bulk_table")
      );
    }
    if (path === "/change-password") {
    return location.pathname === "/change-password";
  }
    return location.pathname.startsWith(path);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Header */}
      <motion.header
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          padding: "14px 40px",
          width: isSidebarOpen ? "calc(100% - 250px)" : "calc(100% - 60px)",
          transition: "width 0.3s ease, margin-left 0.3s ease",
          marginLeft: isSidebarOpen ? "250px" : "60px",
          backgroundColor: "#007bff",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          top: "0",
          left: "0",
          height: "60px",
          zIndex: "1000",
        }}
      >
        <button
          style={{
            border: "none",
            backgroundColor: "transparent",
            color: "white",
          }}
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <FaBars size={20} />
        </button>

        <nav style={{ position: "relative" }}>
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            style={{
              backgroundColor: "transparent",
              color: "white",
              border: "none",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "8px 10px",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            <User size={20} /> Profile
          </button>
          <AnimatePresence>
            {showDropdown && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                style={{
                  position: "absolute",
                  right: 0,
                  top: "100%",
                  background: "white",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  minWidth: "150px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                  padding: "5px 0",
                }}
              >
                <Link
                  to="/change-password"
                  style={{
                    display: "block",
                    padding: "10px",
                    textDecoration: "none",
                    color: "#333",
                  }}
                >
                  Change Password
                </Link>
                <button
                  onClick={() => {
                    localStorage.removeItem("token");
                    window.location.href = "/";
                  }}
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "left",
                    background: "none",
                    border: "none",
                    padding: "10px",
                    color: "red",
                    cursor: "pointer",
                  }}
                >
                  Log Out
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </nav>
      </motion.header>

      {/* Sidebar */}
      <motion.aside
        initial={{ width: isSidebarOpen ? 60 : 250 }}
        animate={{ width: isSidebarOpen ? 250 : 60 }}
        transition={{ duration: 0.3 }}
        style={{
          height: "100vh",
          top: "0",
          left: "0",
          position: "fixed",
          backgroundColor: "#343a40",
          color: "white",
          padding: "20px 10px",
        }}
      >
        <nav>
          <h4 style={{ textAlign: "center", margin: "0 0 20px" }}>
            {isSidebarOpen ? "Zippy Admin" : "Z.A"}
          </h4>
          <ul style={{ listStyle: "none", padding: "0", marginTop: "20px" }}>
            {[
              {
                path: "/user-list",
                icon: <SquaresFour size={20} />,
                label: "User List",
              },
              {
                path: "/content",
                icon: <Book size={20} />,
                label: "Content",
              },
              // { path: "/album", icon: <Image size={20} />, label: "Album" },
              {
                path: "/chapters",
                icon: <BookOpen size={20} />,
                label: "Chapters",
              },
              {
                path: "/characters",
                icon: <Star size={20} />,
                label: "Characters",
              },
              {
                path: "/bulk_upload",
                icon: <UploadSimple size={20} />,
                label: "Bulk Upload",
              },
              {
                path: "/radio",
                icon: <Radio size={20} />,
                label: "Radio",
              },
              {
                path: "/sleep",
                icon: <BiSleepy size={20} />,
                label: "Sleep",
              },
              // {
              //   path: "/report",
              //   icon: <FaRegFileAlt size={20} />,
              //   label: "Report",
              // }, 
              {
                path: "/log",
                icon: <Cast size={20} />,
                label: "Logs",
              },
              {
                path: "/feedback",
                icon: <MessagesSquare size={20} />,
                label: "Feedback",
              },             

            ].map(({ path, icon, label }) => (
              <motion.li
                key={path}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link
                  to={path}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    textDecoration: "none",
                    color: "white",
                    padding: "10px",
                    borderRadius: "4px",
                    backgroundColor: isActiveLink(path)
                      ? "#007bff"
                      : "transparent",
                    transition: "background 0.3s ease",
                  }}
                >
                  {icon} {isSidebarOpen && <span>{label}</span>}
                </Link>
              </motion.li>
            ))}
          </ul>
        </nav>
      </motion.aside>

      {/* Main Content */}
      <main
        style={{
          marginLeft: isSidebarOpen ? "250px" : "60px",
          transition: "margin-left 0.3s ease",
          padding: "20px",
          backgroundColor: "#f8f9fa",
          marginTop: "60px",
          flexGrow: 1,
        }}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default Sidebar;
